var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// jscpd:ignore-start
import React, { useEffect, useState, useRef } from 'react';
import { Autocomplete, Box, Grid, Typography, Button, IconButton, MenuItem, TextField } from '@mui/material';
import { ArrowBackIos, ArrowForwardIos, Settings as SettingsIcon, Lock as LockIcon } from '@mui/icons-material';
import { useSnackbar } from 'notistack';
import InputDados from '../../../components/input_dados';
import ContainerPainel from '../../../components/container_painel';
import { BoxPrincipal } from '../../../components/grid_box';
import { PaginationModelDefault } from '../../../components/grid';
import { getAnosReferencia, getMascaraMoeda, getFloat } from '../../../utils';
import { FUNCIONALIDADES, PAGINAS } from '../../../routes';
import { useAuth } from '../../../contexts/auth/AuthContext';
import { GridFolhaBase } from '../components/GridFolhaBase';
import { calcularTotaisFolhaMensal } from '../folhas_mensais/folhas_mensais.utils';
import { adicionarLancamentoManual, getCombosListar, getFolhasComplementares, removerLancamentoManual, abrirFolhaComplementar, fecharFolhaComplementar, validarFechamentoFolha, getInstituicoesPorAno, getPeriodosPorAno, buscarFolhasLancamento, buscarColaboradoresFolha, STATUS_API, getRelatorioFolha, getRelatorioContrato, getResumoFolha, getRelatorioAusencia, } from './folhas_complementares.service';
export var FolhasComplementaresListar = function () {
    var _a, _b, _c, _d;
    // NOSONAR
    var _f = useState(true), isLoading = _f[0], setIsLoading = _f[1];
    var _g = useState(true), isLoadingInicio = _g[0], setIsLoadingInicio = _g[1];
    var enqueueSnackbar = useSnackbar().enqueueSnackbar;
    var _h = useState(), folhasPagamentoMes = _h[0], setFolhasPagamentoMes = _h[1];
    var _j = useState([]), folhasRegistros = _j[0], setFolhasRegistros = _j[1];
    var _k = useState([]), instituicoesDisponiveis = _k[0], setInstituicoesDisponiveis = _k[1];
    var _l = useState([]), rublicasDisponiveis = _l[0], setRublicasDisponiveis = _l[1];
    var _m = useState([]), tiposRegimesDisponiveis = _m[0], setTiposRegimesDisponiveis = _m[1];
    var anosDisponiveis = useState(getAnosReferencia())[0];
    var _o = useState([]), reeducandosDisponiveis = _o[0], setReeducandosDisponiveis = _o[1];
    var _p = useState([]), folhasLancamentoDisponiveis = _p[0], setFolhasLancamentoDisponiveis = _p[1];
    var _q = useState([]), periodosDisponiveis = _q[0], setPeriodosDisponiveis = _q[1];
    var _r = useState(new Date().getFullYear()), buscaAnoReferencia = _r[0], setBuscaAnoReferencia = _r[1];
    var _s = useState(-1), buscaInstituicao = _s[0], setBuscaInstituicao = _s[1];
    var _t = useState(-1), buscaPeriodo = _t[0], setBuscaPeriodo = _t[1];
    var _u = useState(-1), buscaTipoRegime = _u[0], setBuscaTipoRegime = _u[1];
    var _v = useState(-1), buscaReeducando = _v[0], setBuscaReeducando = _v[1];
    var _w = useState(-1), buscaLancamentoFolha = _w[0], setBuscaLancamentoFolha = _w[1];
    var _x = useState(null), folhaSelecionada = _x[0], setFolhaSelecionada = _x[1];
    var _y = useState(null), colaboradorSelecionado = _y[0], setColaboradorSelecionado = _y[1];
    var _z = useState(''), inputBuscaFolha = _z[0], setInputBuscaFolha = _z[1];
    var _0 = useState(''), inputBuscaColaborador = _0[0], setInputBuscaColaborador = _0[1];
    var _1 = useState(new Date().getMonth() + 1), buscaMesReferencia = _1[0], setBuscaMesReferencia = _1[1];
    var totalProventos = 0;
    var totalDescontos = 0;
    var totalTaxas = 0;
    var totalLiquido = 0;
    var _2 = useState(0), totalRegistros = _2[0], setTotalRegistros = _2[1];
    var _3 = useState(PaginationModelDefault), paginationModel = _3[0], setPaginationModel = _3[1];
    var _4 = useState(false), folhaAdmin = _4[0], setFolhaAdmin = _4[1];
    var _5 = useState(0), forceRender = _5[0], setForceRender = _5[1];
    var _6 = useState(false), desabilitarCampos = _6[0], setDesabilitarCampos = _6[1];
    var _7 = useState(null), msgErro = _7[0], setMsgErro = _7[1];
    var buscaFolhaRequestRef = useRef(0);
    var buscaColaboradorRequestRef = useRef(0);
    var triggerReRender = function () { return setForceRender(function (prev) { return prev + 1; }); };
    var getFolhaOptionLabel = function (folha) { return (folha ? "".concat(folha.id, " - ").concat(folha.nome) : ''); };
    var getColaboradorOptionLabel = function (c) {
        if (!c)
            return '';
        var label = c.nome;
        if (c.cpf) {
            label += " \u2022 CPF: ".concat(c.cpf);
        }
        return label;
    };
    var getAcoesFuncionalidade = useAuth().getAcoesFuncionalidade;
    var acoesFuncionalidade = getAcoesFuncionalidade(FUNCIONALIDADES.FOLHAS_COMPLEMENTARES);
    var calcularValoresCorretos = function (row) { return calcularTotaisFolhaMensal(row); };
    useEffect(function () {
        carregarDados();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [paginationModel]);
    useEffect(function () {
        if (isLoadingInicio) {
            setIsLoadingInicio(false);
        }
        else {
            setPaginationModel(function (prev) { return (__assign(__assign({}, prev), { page: 0 })); });
        }
    }, [buscaAnoReferencia, buscaMesReferencia, buscaInstituicao, buscaTipoRegime, buscaReeducando, buscaLancamentoFolha, buscaPeriodo, isLoadingInicio]);
    useEffect(function () {
        carregarDadosAuxiliares();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(function () {
        var carregar = function () { return __awaiter(void 0, void 0, void 0, function () {
            var resp, respPeriodos;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getInstituicoesPorAno(buscaAnoReferencia)];
                    case 1:
                        resp = _a.sent();
                        setInstituicoesDisponiveis(Array.isArray(resp) ? resp : []);
                        return [4 /*yield*/, getPeriodosPorAno(buscaAnoReferencia)];
                    case 2:
                        respPeriodos = _a.sent();
                        setPeriodosDisponiveis(Array.isArray(respPeriodos) ? respPeriodos : []);
                        return [2 /*return*/];
                }
            });
        }); };
        carregar();
        setBuscaInstituicao(-1);
        setBuscaPeriodo(-1);
        setBuscaLancamentoFolha(-1);
        setFolhaSelecionada(null);
        setFolhasLancamentoDisponiveis([]);
        setInputBuscaFolha('');
        setInputBuscaColaborador('');
        setReeducandosDisponiveis([]);
        setColaboradorSelecionado(null);
        setBuscaReeducando(-1);
    }, [buscaAnoReferencia]);
    useEffect(function () {
        var termo = inputBuscaFolha.trim();
        buscaFolhaRequestRef.current += 1;
        if (folhaSelecionada && termo === getFolhaOptionLabel(folhaSelecionada))
            return;
        if (termo.length < 3) {
            setFolhasLancamentoDisponiveis([]);
            return;
        }
        var reqId = buscaFolhaRequestRef.current;
        var timeout = setTimeout(function () { return __awaiter(void 0, void 0, void 0, function () {
            var resp, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, buscarFolhasLancamento(buscaAnoReferencia, termo, buscaInstituicao === -1 ? null : buscaInstituicao)];
                    case 1:
                        resp = _b.sent();
                        if (reqId === buscaFolhaRequestRef.current)
                            setFolhasLancamentoDisponiveis(Array.isArray(resp) ? resp : []);
                        return [3 /*break*/, 3];
                    case 2:
                        _a = _b.sent();
                        if (reqId === buscaFolhaRequestRef.current)
                            setFolhasLancamentoDisponiveis([]);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); }, 600);
        return function () { return clearTimeout(timeout); };
    }, [inputBuscaFolha, buscaAnoReferencia, buscaInstituicao, folhaSelecionada]);
    useEffect(function () {
        var termo = inputBuscaColaborador.trim();
        buscaColaboradorRequestRef.current += 1;
        if (colaboradorSelecionado && termo === getColaboradorOptionLabel(colaboradorSelecionado))
            return;
        if (termo.length < 3 || buscaLancamentoFolha === -1) {
            setReeducandosDisponiveis([]);
            return;
        }
        var reqId = buscaColaboradorRequestRef.current;
        var timeout = setTimeout(function () { return __awaiter(void 0, void 0, void 0, function () {
            var resp, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, buscarColaboradoresFolha(buscaAnoReferencia, termo, buscaInstituicao === -1 ? null : buscaInstituicao, buscaLancamentoFolha)];
                    case 1:
                        resp = _b.sent();
                        if (reqId === buscaColaboradorRequestRef.current)
                            setReeducandosDisponiveis(Array.isArray(resp) ? resp : []);
                        return [3 /*break*/, 3];
                    case 2:
                        _a = _b.sent();
                        if (reqId === buscaColaboradorRequestRef.current)
                            setReeducandosDisponiveis([]);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); }, 600);
        return function () { return clearTimeout(timeout); };
    }, [inputBuscaColaborador, buscaAnoReferencia, buscaInstituicao, buscaLancamentoFolha, colaboradorSelecionado]);
    var carregarDadosAuxiliares = function () { return __awaiter(void 0, void 0, void 0, function () {
        var acoesAdmin, comboListar;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsLoading(true);
                    acoesAdmin = getAcoesFuncionalidade(FUNCIONALIDADES.FOLHA_ADMIN);
                    setFolhaAdmin(!!(acoesAdmin === null || acoesAdmin === void 0 ? void 0 : acoesAdmin['VISUALIZAR']));
                    return [4 /*yield*/, getCombosListar()];
                case 1:
                    comboListar = _a.sent();
                    if ((comboListar === null || comboListar === void 0 ? void 0 : comboListar.Status) !== STATUS_API.ERRO) {
                        setTiposRegimesDisponiveis(comboListar.tipos_regimes);
                        setRublicasDisponiveis(comboListar.rubricas);
                    }
                    setIsLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var carregarDados = function () { return __awaiter(void 0, void 0, void 0, function () {
        var resposta, dados, total_registros;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!(buscaAnoReferencia && buscaMesReferencia && buscaLancamentoFolha && buscaLancamentoFolha !== -1))
                        return [2 /*return*/];
                    setIsLoading(true);
                    return [4 /*yield*/, getFolhasComplementares(buscaAnoReferencia.toString(), buscaMesReferencia.toString(), buscaInstituicao === -1 ? null : buscaInstituicao.toString(), buscaTipoRegime === -1 ? null : buscaTipoRegime.toString(), buscaReeducando === -1 ? null : buscaReeducando.toString(), buscaLancamentoFolha.toString(), paginationModel, buscaPeriodo === -1 ? null : buscaPeriodo.toString())];
                case 1:
                    resposta = _b.sent();
                    if ((resposta === null || resposta === void 0 ? void 0 : resposta.Status) === STATUS_API.ERRO) {
                        setMsgErro(resposta.Mensagem);
                        setFolhasRegistros([]);
                    }
                    else if (resposta) {
                        dados = resposta.dados, total_registros = resposta.total_registros;
                        setFolhasPagamentoMes(dados);
                        setFolhasRegistros((dados === null || dados === void 0 ? void 0 : dados.registros) || []);
                        setDesabilitarCampos(((_a = dados === null || dados === void 0 ? void 0 : dados.folha_complementar_situacao) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === 'FECHADA');
                        setMsgErro(null);
                        setTotalRegistros(total_registros);
                    }
                    setIsLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var meses = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];
    var alterarMes = function (direcao) {
        var m = buscaMesReferencia + direcao;
        var a = buscaAnoReferencia;
        if (m > 12) {
            a += 1;
            m = 1;
        }
        if (m < 1) {
            a -= 1;
            m = 12;
        }
        if (anosDisponiveis.some(function (item) { return item.value === a; })) {
            setBuscaAnoReferencia(a);
            setBuscaMesReferencia(m);
        }
    };
    var adicionarLancamento = function (contrato_id, rubrica_id, valor, recorrente) { return __awaiter(void 0, void 0, void 0, function () {
        var v, resp;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!contrato_id || !rubrica_id)
                        return [2 /*return*/];
                    v = getFloat(valor);
                    if (!valor || valor.trim() === '' || Number.isNaN(v) || v <= 0) {
                        alert('O valor do lançamento não pode ser números negativos ou Zero.');
                        return [2 /*return*/];
                    }
                    setIsLoading(true);
                    return [4 /*yield*/, adicionarLancamentoManual(contrato_id, rubrica_id, v, buscaAnoReferencia, buscaMesReferencia, recorrente)];
                case 1:
                    resp = _a.sent();
                    if ((resp === null || resp === void 0 ? void 0 : resp.Status) === 'OK') {
                        carregarDados();
                        triggerReRender();
                    }
                    else {
                        alert(resp ? resp.Mensagem : 'Erro ao executar a solicitação');
                    }
                    setIsLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var removerLancamento = function (_contrato_id, lancamento) { return __awaiter(void 0, void 0, void 0, function () {
        var resp;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!confirm('Deseja realmente remover o lançamento?'))
                        return [2 /*return*/];
                    setIsLoading(true);
                    return [4 /*yield*/, removerLancamentoManual(lancamento.id)];
                case 1:
                    resp = _a.sent();
                    if ((resp === null || resp === void 0 ? void 0 : resp.Status) === 'OK') {
                        carregarDados();
                        triggerReRender();
                    }
                    else {
                        alert(resp ? resp.Mensagem : 'Erro ao executar a solicitação');
                    }
                    setIsLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var downloadRelatorioReeducando = function (contrato_id) { return __awaiter(void 0, void 0, void 0, function () {
        var doc, link;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsLoading(true);
                    return [4 /*yield*/, getRelatorioContrato(contrato_id.toString(), buscaAnoReferencia.toString(), buscaMesReferencia.toString())];
                case 1:
                    doc = _a.sent();
                    if (doc) {
                        link = document.createElement('a');
                        link.href = doc;
                        link.download = "relatorio_reeducando_".concat(contrato_id, ".pdf");
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        window.URL.revokeObjectURL(doc);
                    }
                    setIsLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var downloadRelatorioFolha = function () { return __awaiter(void 0, void 0, void 0, function () {
        var doc, link;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsLoading(true);
                    return [4 /*yield*/, getRelatorioFolha(buscaAnoReferencia.toString(), buscaMesReferencia.toString(), buscaInstituicao !== -1 ? buscaInstituicao.toString() : null, buscaTipoRegime !== -1 ? buscaTipoRegime.toString() : null, buscaReeducando !== -1 ? buscaReeducando.toString() : null, buscaLancamentoFolha.toString())];
                case 1:
                    doc = _a.sent();
                    if (doc) {
                        link = document.createElement('a');
                        link.href = doc;
                        link.download = "relatorio_folha_".concat(buscaAnoReferencia, "_").concat(buscaMesReferencia, ".pdf");
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        window.URL.revokeObjectURL(doc);
                    }
                    setIsLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var downloadResumoFolha = function () { return __awaiter(void 0, void 0, void 0, function () {
        var doc, link;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsLoading(true);
                    return [4 /*yield*/, getResumoFolha(buscaAnoReferencia.toString(), buscaMesReferencia.toString(), buscaInstituicao !== -1 ? buscaInstituicao.toString() : null, buscaTipoRegime !== -1 ? buscaTipoRegime.toString() : null, buscaReeducando !== -1 ? buscaReeducando.toString() : null, buscaLancamentoFolha.toString())];
                case 1:
                    doc = _a.sent();
                    if (doc) {
                        link = document.createElement('a');
                        link.href = doc;
                        link.download = "resumo_folha_".concat(buscaAnoReferencia, "_").concat(buscaMesReferencia, ".pdf");
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        window.URL.revokeObjectURL(doc);
                    }
                    setIsLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var downloadRelatorioAusentes = function () { return __awaiter(void 0, void 0, void 0, function () {
        var doc, link;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsLoading(true);
                    return [4 /*yield*/, getRelatorioAusencia(buscaAnoReferencia.toString(), buscaMesReferencia.toString(), buscaInstituicao !== -1 ? buscaInstituicao.toString() : null, buscaTipoRegime !== -1 ? buscaTipoRegime.toString() : null, buscaReeducando !== -1 ? buscaReeducando.toString() : null, buscaLancamentoFolha.toString())];
                case 1:
                    doc = _a.sent();
                    if (doc) {
                        link = document.createElement('a');
                        link.href = doc;
                        link.download = "relatorio_ausencias_".concat(buscaAnoReferencia, "_").concat(buscaMesReferencia, ".pdf");
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        window.URL.revokeObjectURL(doc);
                    }
                    setIsLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var alterarSituacaoFolha = function () { return __awaiter(void 0, void 0, void 0, function () {
        var resp_1, validacao, mensagem, resp;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (((_a = folhasPagamentoMes === null || folhasPagamentoMes === void 0 ? void 0 : folhasPagamentoMes.folha_complementar_situacao) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === 'FECHADA') {
                        alert('A folha complementar está fechada.');
                        return [2 /*return*/];
                    }
                    if (!!(folhasPagamentoMes === null || folhasPagamentoMes === void 0 ? void 0 : folhasPagamentoMes.folha_complementar_calculada)) return [3 /*break*/, 2];
                    if (!confirm('Deseja realmente alterar a situação da folha complementar?'))
                        return [2 /*return*/];
                    setIsLoading(true);
                    return [4 /*yield*/, abrirFolhaComplementar(buscaMesReferencia, buscaAnoReferencia)];
                case 1:
                    resp_1 = _d.sent();
                    if ((resp_1 === null || resp_1 === void 0 ? void 0 : resp_1.Status) === 'OK') {
                        alert('Situação da folha alterada com sucesso');
                        carregarDados();
                    }
                    else {
                        alert(resp_1 ? resp_1.Mensagem : 'Erro ao executar a solicitação');
                    }
                    setIsLoading(false);
                    return [2 /*return*/];
                case 2:
                    setIsLoading(true);
                    return [4 /*yield*/, validarFechamentoFolha(buscaInstituicao === -1 ? null : buscaInstituicao)];
                case 3:
                    validacao = _d.sent();
                    if (((_b = validacao === null || validacao === void 0 ? void 0 : validacao.erros) !== null && _b !== void 0 ? _b : []).length > 0) {
                        setIsLoading(false);
                        validacao.erros.forEach(function (e) { return enqueueSnackbar(e, { variant: 'error' }); });
                        return [2 /*return*/];
                    }
                    setIsLoading(false);
                    mensagem = 'A folha de pagamento será fechada impossibilitando edição. Deseja continuar?';
                    if (((_c = validacao === null || validacao === void 0 ? void 0 : validacao.avisos) !== null && _c !== void 0 ? _c : []).length > 0)
                        mensagem = "Aten\u00E7\u00E3o: ".concat(validacao.avisos.join('\n'), "\n\n").concat(mensagem);
                    if (totalLiquido < 0)
                        mensagem = "Aten\u00E7\u00E3o: o l\u00EDquido total deste per\u00EDodo est\u00E1 NEGATIVO (".concat(getMascaraMoeda(totalLiquido), ").\n\n").concat(mensagem);
                    if (!confirm(mensagem))
                        return [2 /*return*/];
                    setIsLoading(true);
                    return [4 /*yield*/, fecharFolhaComplementar(buscaMesReferencia, buscaAnoReferencia)];
                case 4:
                    resp = _d.sent();
                    if ((resp === null || resp === void 0 ? void 0 : resp.Status) === 'OK') {
                        alert('Folha complementar fechada com sucesso');
                        carregarDados();
                    }
                    else {
                        alert(resp ? resp.Mensagem : 'Erro ao executar a solicitação');
                    }
                    setIsLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var MesSelecaoComp = (_jsxs(Box, __assign({ display: 'flex', alignItems: 'center' }, { children: [_jsx(IconButton, __assign({ onClick: function () { return alterarMes(-1); } }, { children: _jsx(ArrowBackIos, {}) })), _jsx(Typography, __assign({ variant: 'h6' }, { children: "".concat(meses[buscaMesReferencia - 1], " - ").concat(buscaAnoReferencia) })), _jsx(IconButton, __assign({ onClick: function () { return alterarMes(1); } }, { children: _jsx(ArrowForwardIos, {}) })), (folhasPagamentoMes === null || folhasPagamentoMes === void 0 ? void 0 : folhasPagamentoMes.folha_complementar_situacao) && (_jsx(IconButton, __assign({ disabled: ((_a = folhasPagamentoMes === null || folhasPagamentoMes === void 0 ? void 0 : folhasPagamentoMes.folha_complementar_situacao) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === 'FECHADA', onClick: folhaAdmin ? alterarSituacaoFolha : function () { return alert('Sem permissão'); } }, { children: _jsxs(Typography, __assign({ variant: 'body2', ml: 1, color: 'textSecondary' }, { children: [folhasPagamentoMes === null || folhasPagamentoMes === void 0 ? void 0 : folhasPagamentoMes.folha_complementar_situacao, ((_b = folhasPagamentoMes === null || folhasPagamentoMes === void 0 ? void 0 : folhasPagamentoMes.folha_complementar_situacao) === null || _b === void 0 ? void 0 : _b.toUpperCase()) === 'FECHADA' && (_jsx(LockIcon, { fontSize: 'small', sx: { ml: 0.5, verticalAlign: 'middle' } }))] })) })))] })));
    return (_jsx(ContainerPainel, __assign({ pagina: PAGINAS.FOLHAS_COMPLEMENTARES, pagina_especifica_permissao: FUNCIONALIDADES.FOLHAS_COMPLEMENTARES }, { children: !isLoadingInicio && (_jsxs(BoxPrincipal, __assign({ width: '90%' }, { children: [_jsxs(Grid, __assign({ container: true, spacing: 2, mb: 2 }, { children: [_jsx(Grid, __assign({ item: true, xs: 3 }, { children: _jsx(InputDados, __assign({ select: true, id: 'ano_referencia', label: 'Ano de Refer\u00EAncia', value: buscaAnoReferencia, onChange: function (e) { return setBuscaAnoReferencia(e.target.value); } }, { children: anosDisponiveis.map(function (item) { return (_jsx(MenuItem, __assign({ value: item.value }, { children: item.label }), item.value)); }) })) })), _jsx(Grid, __assign({ item: true, xs: 3 }, { children: _jsx(Autocomplete, { size: 'small', disabled: !buscaAnoReferencia, options: instituicoesDisponiveis !== null && instituicoesDisponiveis !== void 0 ? instituicoesDisponiveis : [], value: (_c = (instituicoesDisponiveis !== null && instituicoesDisponiveis !== void 0 ? instituicoesDisponiveis : []).find(function (item) { return item.id === buscaInstituicao; })) !== null && _c !== void 0 ? _c : null, getOptionLabel: function (o) { var _a, _b; return (_b = (_a = o === null || o === void 0 ? void 0 : o.dados) === null || _a === void 0 ? void 0 : _a.razao_social) !== null && _b !== void 0 ? _b : ''; }, onChange: function (_e, val) {
                                    var _a;
                                    setBuscaInstituicao((_a = val === null || val === void 0 ? void 0 : val.id) !== null && _a !== void 0 ? _a : -1);
                                    setBuscaLancamentoFolha(-1);
                                    setFolhaSelecionada(null);
                                    setFolhasLancamentoDisponiveis([]);
                                    setInputBuscaFolha('');
                                    setInputBuscaColaborador('');
                                    setReeducandosDisponiveis([]);
                                    setColaboradorSelecionado(null);
                                    setBuscaReeducando(-1);
                                }, renderInput: function (params) { return _jsx(TextField, __assign({}, params, { label: 'Institui\u00E7\u00E3o', placeholder: 'Nome da institui\u00E7\u00E3o' })); } }) })), _jsx(Grid, __assign({ item: true, xs: 3 }, { children: _jsx(Autocomplete, { id: 'folha-lancamento-busca', size: 'small', disabled: !buscaAnoReferencia, options: folhasLancamentoDisponiveis, value: folhaSelecionada, inputValue: inputBuscaFolha, getOptionLabel: getFolhaOptionLabel, onInputChange: function (_e, val, reason) {
                                    if (reason !== 'input' && reason !== 'clear')
                                        return;
                                    setInputBuscaFolha(val);
                                    if (folhaSelecionada && val !== getFolhaOptionLabel(folhaSelecionada)) {
                                        setFolhaSelecionada(null);
                                        setBuscaLancamentoFolha(-1);
                                        setBuscaReeducando(-1);
                                        setColaboradorSelecionado(null);
                                        setReeducandosDisponiveis([]);
                                        setInputBuscaColaborador('');
                                    }
                                }, onChange: function (_e, val) {
                                    var _a;
                                    setFolhaSelecionada(val);
                                    setBuscaLancamentoFolha((_a = val === null || val === void 0 ? void 0 : val.id) !== null && _a !== void 0 ? _a : -1);
                                    setBuscaReeducando(-1);
                                    setColaboradorSelecionado(null);
                                    setReeducandosDisponiveis([]);
                                    setInputBuscaFolha(getFolhaOptionLabel(val));
                                    setInputBuscaColaborador('');
                                }, renderInput: function (params) { return _jsx(TextField, __assign({}, params, { required: true, label: 'Folha (Nome / C\u00F3digo)', size: 'small', fullWidth: true })); } }) })), _jsx(Grid, __assign({ item: true, xs: 3 }, { children: _jsxs(InputDados, __assign({ select: true, id: 'regime_reclusao', label: 'Tipo de Regime', value: buscaTipoRegime, onChange: function (e) { return setBuscaTipoRegime(e.target.value); } }, { children: [_jsx(MenuItem, __assign({ value: '-1' }, { children: "Selecione..." })), tiposRegimesDisponiveis === null || tiposRegimesDisponiveis === void 0 ? void 0 : tiposRegimesDisponiveis.map(function (item) { return (_jsx(MenuItem, __assign({ value: item.id }, { children: item === null || item === void 0 ? void 0 : item.nome }), item.id)); })] })) })), _jsx(Grid, __assign({ item: true, xs: 3 }, { children: _jsx(Autocomplete, { id: 'colaborador-busca', size: 'small', disabled: !buscaAnoReferencia || buscaLancamentoFolha === -1, options: reeducandosDisponiveis, inputValue: inputBuscaColaborador, value: colaboradorSelecionado, getOptionLabel: getColaboradorOptionLabel, onInputChange: function (_e, val, reason) {
                                    if (reason !== 'input' && reason !== 'clear')
                                        return;
                                    setInputBuscaColaborador(val);
                                    if (reason === 'clear' || (colaboradorSelecionado && val !== getColaboradorOptionLabel(colaboradorSelecionado))) {
                                        setColaboradorSelecionado(null);
                                        setBuscaReeducando(-1);
                                    }
                                }, onChange: function (_e, val) {
                                    var _a;
                                    setColaboradorSelecionado(val);
                                    setBuscaReeducando((_a = val === null || val === void 0 ? void 0 : val.id) !== null && _a !== void 0 ? _a : -1);
                                    setInputBuscaColaborador(getColaboradorOptionLabel(val));
                                }, renderInput: function (params) { return _jsx(TextField, __assign({}, params, { label: 'Colaborador (Nome / CPF / Matr\u00EDcula)', size: 'small', fullWidth: true })); } }) })), _jsx(Grid, __assign({ item: true, xs: 3 }, { children: _jsxs(InputDados, __assign({ select: true, id: 'periodo', label: 'Per\u00EDodo', value: buscaPeriodo, onChange: function (e) { return setBuscaPeriodo(e.target.value); } }, { children: [_jsx(MenuItem, __assign({ value: '-1' }, { children: "Selecione..." })), periodosDisponiveis === null || periodosDisponiveis === void 0 ? void 0 : periodosDisponiveis.map(function (item) { return _jsx(MenuItem, __assign({ value: item.id }, { children: "Dia ".concat(item.dia_inicio, " a ").concat(item.dia_fim) }), item.id); })] })) })), ((_d = folhasPagamentoMes === null || folhasPagamentoMes === void 0 ? void 0 : folhasPagamentoMes.folha_complementar_situacao) === null || _d === void 0 ? void 0 : _d.toUpperCase()) === 'ABERTA' && (folhasPagamentoMes === null || folhasPagamentoMes === void 0 ? void 0 : folhasPagamentoMes.folha_complementar_calculada) && (_jsx(Grid, __assign({ item: true, xs: 3, display: 'flex', alignItems: 'center' }, { children: _jsx(Button, __assign({ variant: 'contained', color: 'success', startIcon: _jsx(SettingsIcon, {}), onClick: alterarSituacaoFolha, disabled: !folhaAdmin, sx: { height: 40 } }, { children: "Gerar fechamento complementar" })) })))] })), buscaLancamentoFolha && buscaLancamentoFolha !== -1 && (folhasPagamentoMes === null || folhasPagamentoMes === void 0 ? void 0 : folhasPagamentoMes.folha_complementar_calculada) && !msgErro ? (_jsx(GridFolhaBase, { folhasRegistros: folhasRegistros, totalProventos: totalProventos, totalDescontos: totalDescontos, totalTaxas: totalTaxas, totalLiquido: totalLiquido, totalRegistros: totalRegistros, isLoading: isLoading, paginationModel: paginationModel, setPaginationModel: setPaginationModel, forceRender: forceRender, desabilitarCampos: desabilitarCampos, folhaAdmin: folhaAdmin, acoesFuncionalidade: acoesFuncionalidade, rublicasDisponiveis: rublicasDisponiveis, mesSelecaoComp: MesSelecaoComp, downloadRelatorioFolha: downloadRelatorioFolha, downloadResumoFolha: downloadResumoFolha, downloadRelatorioAusentes: downloadRelatorioAusentes, downloadRelatorioReeducando: downloadRelatorioReeducando, adicionarLancamento: adicionarLancamento, removerLancamento: removerLancamento, calcularValoresCorretos: calcularValoresCorretos, exibirOpcaoRecorrente: true })) : (_jsxs(Box, __assign({ p: 2, pt: 5, mt: 4, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', sx: { backgroundColor: '#f9f9f9', borderRadius: 2, textAlign: 'center', padding: 4 } }, { children: [MesSelecaoComp, _jsx(Typography, __assign({ variant: 'body1', gutterBottom: true, mt: 3 }, { children: buscaLancamentoFolha === -1
                                ? 'Selecione uma folha para visualizar os dados. A instituição é opcional para refinar a busca.'
                                : msgErro !== null && msgErro !== void 0 ? msgErro : 'A folha complementar referente a este período ainda não foi calculada.' })), _jsx(Button, __assign({ variant: 'contained', color: 'success', onClick: alterarSituacaoFolha, startIcon: _jsx(SettingsIcon, {}), sx: { textTransform: 'none', padding: '8px 16px', marginTop: 5 }, disabled: !folhaAdmin || buscaLancamentoFolha === -1 || !folhasPagamentoMes || !!msgErro }, { children: "Calcular folha complementar" }))] })))] }))) })));
};
export default FolhasComplementaresListar;
